import { InjectionToken, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SnackBarModule } from '@epicuro-next/ataraxia/snack-bar';
import { DataContentModule } from '@epicuro-next/data/content';
import { DataDocumentsModule } from '@epicuro-next/data/documents';
import { DataUsersModule } from '@epicuro-next/data/users';
import {
  BROWSER_STORAGE_SERVICE,
  LocalStorageService,
  StorageModule,
} from '@epicuro-next/platform/storage';
import { storageMetaReducer } from '@epicuro-next/state/meta-reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { UserTermsGuard } from './guards/user-terms-guard.service.';
import {
  PrivacyStatementEffects,
  TradeTermsPageEffects,
  UserAgreementEffects,
  UserAvatarEffects,
  UserEffects,
  UserLanguageEffects,
  UserPasswordEffects,
  UserPreferencesEffects,
  UserTermsEffects,
} from './store/effects';
import {
  reducer,
  storageKeys,
  userFeatureKey,
} from './store/user-state.reducer';
import { AuthenticationModule } from '@epicuro-next/platform/authentication';
import { ForgotPasswordEffects } from './store/effects/forgot-password.effects';

const USER_MENU_TOKEN = new InjectionToken('USER_MENU_TOKEN Injection Token');

const USER_MENU_STORAGE_KEY = new InjectionToken(
  'USER_MENU_STORAGE_KEY Injection Token',
);
const USER_MENU_STORAGE_KEYS = new InjectionToken(
  'USER_MENU_STORAGE_KEYS Injection Token',
);

export function getUserStateFactoryConfig(
  saveKeys: string[],
  browserStorageKey: string,
  storageService: BROWSER_STORAGE_SERVICE,
) {
  return {
    metaReducers: [
      storageMetaReducer(saveKeys, browserStorageKey, storageService),
    ],
  };
}

@NgModule({
  imports: [
    DataUsersModule,
    DataDocumentsModule,
    DataContentModule,
    StoreModule.forFeature(userFeatureKey, reducer, USER_MENU_TOKEN),
    EffectsModule.forFeature([
      UserAvatarEffects,
      UserPasswordEffects,
      UserLanguageEffects,
      UserEffects,
      UserTermsEffects,
      UserPreferencesEffects,
      PrivacyStatementEffects,
      UserAgreementEffects,
      TradeTermsPageEffects,
      ForgotPasswordEffects,
    ]),
    SnackBarModule,
    StorageModule,
    DataDocumentsModule,
    RouterModule,
    AuthenticationModule,
  ],
  providers: [
    UserTermsGuard,
    {
      provide: USER_MENU_STORAGE_KEY,
      useValue: `${userFeatureKey}_storage`,
    },
    {
      provide: USER_MENU_STORAGE_KEYS,
      useValue: storageKeys,
    },
    {
      provide: USER_MENU_TOKEN,
      deps: [
        USER_MENU_STORAGE_KEYS,
        USER_MENU_STORAGE_KEY,
        LocalStorageService,
      ],
      useFactory: getUserStateFactoryConfig,
    },
  ],
})
export class UserStateModule {}
export * from './store/actions';
export * from './store/user-state.selectors';
